// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"173":"wiki-tools","284":"data-table","660":"yeti"}[chunkId] + "." + {"173":"7b20b8bb","284":"7a2dd8d5","660":"47c2de13"}[chunkId] + ".css";
};